import {connect} from "react-redux"
import {createSelector} from "reselect"
import {State} from "../../ducks"
import {createRecentQuery} from "../../ducks/recents"
import {search} from "../../ducks/search"

const selectFeatures = (state: State) => state.settings
const selectProducts = (state: State) => state.autocomplete.products

const makeSelectProductsMaxItems = createSelector([selectFeatures, selectProducts], (settings, products) => {
    const ProductsMaxItems = {...settings.enrichedMaxItems}

    if (ProductsMaxItems && products && products.length > 0) {
        if (ProductsMaxItems.xxl === undefined) {
            ProductsMaxItems.xxl = ProductsMaxItems.xl
        }
        Object.keys(ProductsMaxItems).forEach(key => {
            if (products.length <= 4) {
                const defaultMaxItem = 5
                ProductsMaxItems[key] = ProductsMaxItems[key] > defaultMaxItem ? ProductsMaxItems[key] : defaultMaxItem
                return false
            }
            if (ProductsMaxItems[key] > products.length) {
                ProductsMaxItems[key] = products.length
            }
        })
    }

    return ProductsMaxItems
})

export const mapStateToProps = (state: State) => {
    const {
        autoComplete: {
            searchLinktext,
            enrich: {termTitle},
        },
    } = state.text
    const {products, q} = state.autocomplete
    const {siteUrl, currencyCode, cleanSiteUrl} = state.request
    const {threeFourImageryEnabled, enrichedSearchImagePath} = state.settings
    const language = state.data?.language
    const territory = state.data?.territory
    const locale = `${language}-${territory}`
    const ProductsMaxItems = makeSelectProductsMaxItems(state)
    const realm = state.data?.realm
    const isTPClient = realm !== "next"
    const isRTL = state.textAlignment === "rtl"

    const {variant, iconsVersionPath, xxlBreakpointEnabled, isTpSuperLite} = state.settings

    return {
        products,
        term: q,
        siteUrl,
        cleanSiteUrl,
        isTpSuperLite,
        maxItems: ProductsMaxItems,
        text: {searchLinktext, termTitle},
        currencyCode,
        locale,
        realm,
        templating: state.template,
        threeFourImageryEnabled,
        enrichedSearchImagePath,
        isTPClient,
        variant,
        iconsVersionPath,
        isRTL,
        xxlBreakpointEnabled,
    }
}

export const mapDispatchToProps = dispatch => ({
    handleSuggestionClick: (suggestion: string, siteUrl: string): void => {
        dispatch(createRecentQuery(suggestion))
        dispatch(search(siteUrl, suggestion))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
